function r(e) {
  return e <= 1.2 ? "Bad" : e <= 2.2 ? "Poor" : e <= 3.2 ? "Average" : e <= 4.2 ? "Great" : "Excellent";
}
function t(e) {
  return Math.round((e + Number.EPSILON) * 10) / 10;
}
export {
  t as getDecimalScore,
  r as getRatingLabel
};
